export const ProviderPrivatePracticeConfig = [
  {
    id: "id",
    label: "ID",
    dataKey: "id",
    cols: 12,
    hide: true,
  },
  {
    id: "first_name",
    label: "First Name",
    dataKey: "first_name",
    cols: 12,
    required: true,
    headerTitle: "Provider Details",
  },
  {
    id: "last_name",
    label: "Last Name",
    dataKey: "last_name",
    cols: 12,
    required: true,
  },
  {
    id: "medicaid_id",
    label: "Medicaid ID (optional)",
    dataKey: "medicaid_id",
    cols: 12,
  },
  {
    id: "npi_number",
    label: "NPI Number",
    dataKey: "npi_number",
    cols: 12,
  },
  {
    id: "specialty",
    label: "Specialty",
    dataKey: "specialty",
    cols: 12,
  },
  {
    id: "accepts_insurance",
    label: "Accepts Insurance",
    dataKey: "accepts_insurance",
    cols: 12,
    type: "yes_no",
    divider: true,
  },
  {
    id: "email",
    label: "Email Address",
    dataKey: "email",
    cols: 12,
    required: true,
  },
  {
    id: "phone",
    label: "Provider's Phone Number",
    dataKey: "phone",
    cols: 12,
    required: true,
    headerTitle: "Contact Information",
  },
  {
    id: "fax_number",
    label: "Provider's Fax Number (optional)",
    dataKey: "fax_number",
    cols: 12,
    divider: true,
  },
  {
    id: "physical_address",
    label: "Address",
    dataKey: "physical_address",
    cols: 12,
    required: true,
  },
  {
    id: "physical_address_2",
    label: "Address 2 (optional)",
    dataKey: "physical_address_2",
    cols: 12,
  },
  {
    id: "city",
    label: "City",
    dataKey: "city",
    cols: 12,
    required: true,
  },
  {
    id: "state",
    label: "State",
    dataKey: "state",
    cols: 12,
    required: true,
  },
  {
    id: "zip_code",
    label: "ZIP Code",
    dataKey: "zip_code",
    cols: 12,
    required: true,
  },
  {
    id: "website",
    label: "Website (optional)",
    dataKey: "website",
    cols: 12,
  },
];
